import { render, staticRenderFns } from "./EditUbicazionePadre.vue?vue&type=template&id=1c9bc6e6&"
import script from "./EditUbicazionePadre.vue?vue&type=script&lang=js&"
export * from "./EditUbicazionePadre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports